import styles from './Navigation.module.css'

export function Breadcrumbs({ items = [], label = 'Breadcrumb', renderLink, className = '' }) {
  return (
    <nav aria-label={label} className={`${styles.breadcrumbs} ${className}`.trim()}>
      <ol className={styles.breadcrumbList}>
        {items.map((item, index) => {
          const current = index === items.length - 1
          const content = current
            ? <span aria-current="page">{item.label}</span>
            : renderLink?.(item) || <a href={item.href} className={styles.breadcrumbLink}>{item.label}</a>
          return <li key={item.key || item.href || item.label} className={styles.breadcrumbItem}>{content}</li>
        })}
      </ol>
    </nav>
  )
}
